const cache: { [key: string]: string } = {};

export function removeSpecialCharacters(word: string = "") {
  if (!word) {
    return "";
  }

  if (cache[word]) return cache[word];

  let modifiedWord = "";

  modifiedWord = `${word}`
    .replace(/[-_&/#,+()$~%.'":*?<>{}\s]/g, "")
    .toLowerCase();

  cache[word] = modifiedWord;

  return modifiedWord;
}

export function areStringsSubstring(
  s1: string,
  s2: string,
  removeSpecialCharacters_ = true
) {
  if (removeSpecialCharacters_) {
    s1 = removeSpecialCharacters(s1);
    s2 = removeSpecialCharacters(s2);
  }

  s1 = s1.toLocaleLowerCase();
  s2 = s2.toLocaleLowerCase();

  return s1.includes(s2) || s2.includes(s1);
}

export function removeUrlTrailingSlash(s: string) {
  try {
    const url = new URL(s);
    const { origin, search } = url;
    let { pathname } = url;

    if (pathname === "/") {
      pathname = "";
    }

    let updatedUrl = `${origin}${pathname}`;
    updatedUrl = updatedUrl.replace(/\/$/, "");
    updatedUrl += search;

    return updatedUrl;
  } catch (err) {
    return "";
  }
}

export function padText(text: any, width: number, char = "") {
  text = text + "";
  return text.length >= width
    ? text
    : new Array(width - text.length + 1).join(char) + text;
}
